import React from 'react';
import styles from '../styles/ShakeModal.module.scss';
import Portal from './Portal';
import { useShake } from '../ShakeProvider';
import JobList from './JobList';
import ShakeTemplateForm from './form/ShakeTemplateForm';
import LeftArrowIcon from '../../icons/LeftArrowIcon';

export default function ShakeModal() {
  const { isModalOpen, setModalOpen, selectedTemplate, view, goBack, headerTitle } = useShake();
  if (!isModalOpen || !selectedTemplate) return null;

  const showBack = view === 'job-form' || view === 'job-view';

  return (
    <Portal>
      <div className="shakeScope">
        <div className={styles.backdrop} onClick={() => setModalOpen(false)} />
        <section className={styles.sheet} aria-modal="true" role="dialog">
          <header className={styles.header}>
            <div className={styles.headerLeft}>
              {showBack && (
                <button className={styles.backBtn} onClick={goBack} aria-label="Back">
                  <LeftArrowIcon width={16} height={16} /> Back
                </button>
              )}
            </div>
            <div className={styles.title}>
              {selectedTemplate.name}
              {showBack && <span className={styles.subTitle}>{headerTitle}</span>}
            </div>

            <button className={styles.close} aria-label="Close" onClick={() => setModalOpen(false)}>
              ×
            </button>
          </header>

          <div className={styles.body}>
            {view === 'template' && <JobList template={selectedTemplate} />}
            {(view === 'job-form' || view === 'job-view') && <ShakeTemplateForm />}
          </div>
        </section>
      </div>
    </Portal>
  );
}
